var _circle, _path, _path2, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgGuidelineNoEntry = function SvgImgGuidelineNoEntry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 13,
    fill: "#ED3B50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M13 21a2 2 0 0 1 2-2h12a2 2 0 0 1 0 4H15a2 2 0 0 1-2-2"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "imgGuidelineNoEntry_svg__a",
    width: 42,
    height: 43,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M42 0H0v42h42z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#imgGuidelineNoEntry_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#F48C8C",
    strokeWidth: 3.341,
    d: "M21.95 40.068q-.471.023-.95.023c-10.544 0-19.091-8.547-19.091-19.09 0-10.545 8.547-19.092 19.09-19.092 10.545 0 19.092 8.548 19.092 19.091q0 .24-.006.477"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F48C8C",
    fillRule: "evenodd",
    d: "m41.33 25.035-.45 1.608q-.232.832-.53 1.636l-3.132-1.163q.25-.674.445-1.37l.449-1.61zm-2.44 6.353a21 21 0 0 1-1.952 2.824l-2.582-2.119a17.5 17.5 0 0 0 1.638-2.37zm-4.34 5.29a21 21 0 0 1-2.76 2.04l-1.757-2.841q1.232-.763 2.317-1.714zm-5.82 3.598q-.794.324-1.617.584l-1.594.5-1.002-3.187 1.594-.5q.69-.217 1.355-.49z",
    clipRule: "evenodd"
  }))));
};
export default SvgImgGuidelineNoEntry;